import React, { useEffect, useState } from "react";
import {
    Elements,
    useStripe,
} from "@stripe/react-stripe-js";

import OrderCompleteDetails from "../components/OrderCompleteDetails";
import { loadStripe } from "@stripe/stripe-js";
import { stripeKey } from "../common";

export default function CompletePage() {


    const stripePromise = loadStripe(stripeKey);

    return (
        <Elements options={{}} stripe={stripePromise}>
            <OrderCompleteDetails />
        </Elements>
    );
}